export default __webpack_public_path__ + "static/media/peli.ee6ef566.webp";